var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('navigation'),_vm._v(" "),_c('v-content',{attrs:{"id":"content-wrapper"}},[_c('v-container',{attrs:{"fluid":""}},[_c('nuxt')],1),_vm._v(" "),_c('modal')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }